import React from 'react'
import { IColuna } from "../../types/IColuna";
import { Markup } from "../../types/Markup";
import { GridMarkup } from "./grid-markup/GridMarkup";
import { TotalGeralMarkup } from "./total-geral-markup/TotalGeralMarkup";

export type TelaMarkupContextType = {
    colunas: IColuna[]
    markup: Markup
    markupAtualizado: number
    onToggleColunaSelecionada: (nomeColuna: string, selecionada: boolean) => void;
    onAlterarFonte: (fonte: number) => void
    tamanhoFontePadrao: number
    onToggleSelecionarTodasColunas: (selecionar: boolean) => void;
    onAlterarPrecoAtual: (index: number, precoAtual: string) => void
    onAlterarMargemLucro: (index: number, margemLucro: string) => void
    onAplicarPrecos: () => void
    permiteEngrenagemGrid?: boolean; // 418506
    mascaraPrecoCompra: number
    mascaraPrecoVenda: number
    mascaraQuantidade: number
    exibirNomeReferencia: boolean
    substituirMarkupPorMargem: boolean
    permiteInteragirMargemLucro: boolean
    trocarTermoMarkupPorMargemDeLucro: boolean // 444366
    processando?: boolean // 435964
    somenteLeitura?: boolean // 435964
    dadosAlterados?: boolean // 435964
    simulacaoEmAndamento?: boolean
}

export const TelaMarkupContext = React.createContext<TelaMarkupContextType>({
    colunas: [],
    markup: {} as Markup,
    markupAtualizado: 0,
    onToggleColunaSelecionada: () => { },
    onAlterarFonte: () => { },
    tamanhoFontePadrao: 0,
    onToggleSelecionarTodasColunas: () => { },
    onAlterarPrecoAtual: () => { },
    onAlterarMargemLucro: () => { },
    onAplicarPrecos: () => { },
    permiteEngrenagemGrid: false,
    mascaraPrecoCompra: 0,
    mascaraPrecoVenda: 0,
    mascaraQuantidade: 0,
    exibirNomeReferencia: false,
    substituirMarkupPorMargem: false,
    permiteInteragirMargemLucro: false,
    trocarTermoMarkupPorMargemDeLucro: false,
    processando: false,
    somenteLeitura: false,
    dadosAlterados: false,
    simulacaoEmAndamento: false,
})

export const TelaMarkup = () => {
    return <>
        <GridMarkup />
        <TotalGeralMarkup />
    </>
}
